import React, { FC } from 'react';
import { Button, ButtonProps } from '@mui/material';

const TextButton: FC<ButtonProps> = ({ children, sx, size, ...props }) => (
	<Button
		{...props}
		size="small"
		sx={{
			...sx,
			'&:hover': {
				background: 'transparent'
			},
			minWidth: 0 // default mui-button has min-width, we let the parent control this if needed
		}}
	>
		{children}
	</Button>
);

export default TextButton;
